<template>
    <div class="big_box">
        <div class="img_52 title_center"></div>
        <div class="img_64 content_center"></div>
    </div>
</template>

<script>
module.exports = {
    data() {
        return {}
    },


}
</script>

<style scoped>
.big_box.big_box.big_box{
    height:93%;
}
</style>